import { useMemo } from 'react';
import { holdsPermission } from '@/app/holdsPermission';
import { useSession } from '@/app/session';
import type { PermissionCode } from '@/app/types/PermissionCode';

/**
 * The signed-in account's permission codes as a set, rebuilt only when the session's user
 * changes — not on every render of every screen that asks. Empty while nobody is signed in.
 */
export function useHeldPermissions(): ReadonlySet<string> {
  const { user } = useSession();
  return useMemo(() => new Set(user?.permissions ?? []), [user]);
}

/**
 * Whether the account holds `required` — one code, or several of which any one is enough, as
 * holdsPermission reads it for the sidebar and the route guard.
 */
export function usePermission(required: PermissionCode | readonly PermissionCode[]): boolean {
  return holdsPermission(useHeldPermissions(), required);
}
